module.exports = __webpack_public_path__ + "img/12-1.99f3f151.jpg";